import { render, staticRenderFns } from "./ManageProperty.vue?vue&type=template&id=e1a4dcce&"
import script from "./ManageProperty.vue?vue&type=script&lang=js&"
export * from "./ManageProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports